export default {"src":"/_next/static/media/iconKey.3103ff7f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};